<div class="ef-page">

  <div class="ef-header">
    <div class="ef-header__icon"><mat-icon>payment</mat-icon></div>
    <div>
      <h1 class="ef-header__title">{{ isBail ? (uid ? 'Editar fianza' : 'Nueva fianza') : (uid ? 'Editar anticipo de ' : 'Nuevo anticipo de ') + (isSupplier ? 'proveedor' : 'cliente') }}</h1>
      <p class="ef-header__sub">{{ isBail ? (uid ? 'Modifica los datos de la fianza' : 'Registra una fianza entregada a un proveedor') : uid ? 'Modifica los datos del anticipo' : isSupplier ? 'Registra un pago anticipado a un proveedor' : 'Registra un cobro anticipado de un cliente' }}</p>
    </div>

    <div class="cf-total-cards pf-header-totals" *ngIf="!isLoading && lines.length > 0">
      <div class="cf-total-card">
        <p class="label">Base <strong>{{ subtotal | number:'1.2-2' }} €</strong></p>
      </div>
      <div class="cf-total-card cf-total-card--highlight">
        <p class="label">Total <strong>{{ total | number:'1.2-2' }} €</strong></p>
      </div>
    </div>

    <div class="pf-header-actions">
      <button mat-stroked-button type="button" class="pf-btn-cancel" (click)="onCancel()" [disabled]="isSaving">
        <mat-icon>arrow_back</mat-icon> Volver
      </button>
      <button *ngIf="!isAssigned" mat-flat-button type="button" class="ef-btn-save" (click)="onSave()" [disabled]="isSaving || isLoading">
        <mat-icon>save</mat-icon> Guardar
      </button>
    </div>
  </div>

  <div class="ef-body" *ngIf="!isLoading">
    <p class="ap-assigned" *ngIf="isAssigned">
      <mat-icon>lock</mat-icon>
      <span>{{ isBail ? 'Esta fianza ya está asignada' : 'Este anticipo ya está asignado' }}{{ assignedTo ? ' a ' + assignedTo : isSupplier ? ' a un gasto' : ' a una factura' }} y no se puede modificar. Si necesitas cambiarlo, elimina primero la asignación.</span>
    </p>

    <form [formGroup]="form" class="pf-form">

      <div class="pf-side-by-side">
        <mat-card appearance="outlined" class="tf-card">
          <mat-card-content>
            <div class="tf-section-header">
              <h6 class="tf-section-title">{{ isBail ? 'Datos de la fianza' : 'Datos del anticipo' }}</h6>
            </div>

            <app-autocomplete [control]="form.get('contactUid')" [config]="{
                label: isSupplier ? 'Proveedor' : 'Cliente',
                placeholder: isSupplier ? 'Buscar proveedor...' : 'Buscar cliente...',
                options: contacts
              }">
            </app-autocomplete>

            <app-date [control]="form.get('date')" [config]="{ label: 'Fecha' }"></app-date>

            <mat-form-field *ngIf="isBail" appearance="outline" class="w-100">
              <mat-label>Duración</mat-label>
              <mat-select formControlName="duration">
                <mat-option [value]="1">Corto plazo (565)</mat-option>
                <mat-option [value]="2">Largo plazo (260)</mat-option>
              </mat-select>
              <mat-error>Duración es obligatoria</mat-error>
            </mat-form-field>
          </mat-card-content>
        </mat-card>

        <mat-card appearance="outlined" class="tf-card">
          <mat-card-content>
            <div class="tf-section-header">
              <h6 class="tf-section-title">{{ isSupplier ? 'Pago' : 'Cobro' }}</h6>
            </div>

            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{ isSupplier ? 'Tipo de pago' : 'Tipo de cobro' }}</mat-label>
              <mat-select formControlName="typePay">
                <mat-option *ngFor="let method of payMethods" [value]="method">{{ method }}</mat-option>
              </mat-select>
              <mat-error>{{ isSupplier ? 'Tipo de pago' : 'Tipo de cobro' }} es obligatorio</mat-error>
            </mat-form-field>

            <app-autocomplete *ngIf="isCashRegisterPayment()" [control]="form.get('cashRegisterUid')" [config]="{
                label: 'Caja / Efectivo', placeholder: 'Seleccionar caja...', options: cashRegisters, autoSelectSingle: true }">
            </app-autocomplete>

            <app-autocomplete *ngIf="isBankAccountPayment()" [control]="form.get('bankAccountUid')" [config]="{
                label: 'Cuenta bancaria', placeholder: 'Seleccionar cuenta...', options: bankAccounts, autoSelectSingle: true }">
            </app-autocomplete>

            <app-autocomplete *ngIf="isCardPayment()" [control]="form.get('paymentCardUid')" [config]="{
                label: form.get('typePay').value, placeholder: 'Seleccionar tarjeta...', options: paymentCards, autoSelectSingle: true }">
            </app-autocomplete>

            <app-autocomplete *ngIf="isPartnerPayment()" [control]="form.get('partnerUid')" [config]="{
                label: 'Socio', placeholder: 'Seleccionar socio...', options: partners, autoSelectSingle: true }">
            </app-autocomplete>
          </mat-card-content>
        </mat-card>
      </div>

      <mat-card appearance="outlined" class="tf-card mb-3">
        <mat-card-content>
          <div class="tf-section-header ef-section__head--wrap">
            <h6 class="tf-section-title">Conceptos</h6>
            <span class="ef-section__badge" *ngIf="lines.length">{{ lines.length }}</span>
            <div class="ef-section__head-extra" *ngIf="!isAssigned">
              <button mat-flat-button type="button" (click)="addLine()" class="ef-btn-add-line ef-btn-add-line--primary">
                <mat-icon>add</mat-icon> Línea
              </button>
            </div>
          </div>

          <div *ngIf="lines.length === 0" class="ef-empty-lines" [class.pf-empty-lines--invalid]="submitted">
            <mat-icon>inbox</mat-icon>
            <p>Sin conceptos. Pulsa "Línea" para comenzar.</p>
          </div>

          <ng-container *ngIf="lines.length > 0">
            <div class="lines-scroll" (scroll)="onLinesScroll($event)">
              <div formArrayName="lines" cdkDropList [cdkDropListDisabled]="isAssigned" (cdkDropListDropped)="dropLine($event)" class="lines-container p-2">

                <div *ngFor="let line of visibleLines; let i = index; trackBy: trackByIndex"
                  [formGroupName]="i" cdkDrag
                  class="line-row line-card p-1 mb-1 border rounded">

                  <div class="line-flex">
                    <div class="drag" cdkDragHandle><mat-icon>drag_handle</mat-icon></div>

                    <div class="grow concept">
                      <app-autocomplete [control]="line.get('conceptUid')" [config]="{
                        label: 'Concepto', placeholder: 'Buscar o escribir concepto...', options: concepts,
                        allowCustomValues: true, onChange: onConceptChange.bind(this, line) }">
                      </app-autocomplete>
                    </div>

                    <div class="w-qty">
                      <app-field [control]="line.get('quantity')" [config]="{ label: 'Cantidad', type: 'number' }"></app-field>
                    </div>

                    <div class="w-price">
                      <app-field [control]="line.get('price')" [config]="{ label: 'Precio', type: 'number' }"></app-field>
                    </div>

                    <div class="w-disc">
                      <app-field [control]="line.get('discount')" [config]="{ label: 'Dto.(%)', type: 'number' }"></app-field>
                    </div>

                    <div class="grow taxes">
                      <app-multi-select-autocomplete [control]="line.get('tax')" [config]="{
                        label: 'Impuestos', placeholder: 'Buscar impuesto...', options: taxes,
                        groupBy: 'group', onChange: handleTaxChange, onFocus: handleTaxFocus, lineIndex: i }">
                      </app-multi-select-autocomplete>
                    </div>

                    <div class="end">
                      <span class="ef-line-total">{{ lineTotals[i] | number:'1.2-2' }}€</span>
                      <app-button *ngIf="!isAssigned" icon="delete" variant="danger" className="btn-empty" (click)="removeLine(i)"></app-button>
                    </div>
                  </div>

                </div>

              </div>
            </div>

            <div class="cf-total-cards pf-totals">
              <div class="cf-total-card">
                <p class="label">Base <strong>{{ subtotal | number:'1.2-2' }} €</strong></p>
              </div>
              <div class="cf-total-card">
                <p class="label">{{ taxesLabel }} <strong>{{ taxesTotal | number:'1.2-2' }} €</strong></p>
              </div>
              <div class="cf-total-card" *ngIf="retentionsTotal !== 0">
                <p class="label">Retención <strong>{{ retentionsTotal | number:'1.2-2' }} €</strong></p>
              </div>
              <div class="cf-total-card cf-total-card--highlight">
                <p class="label">Total <strong>{{ total | number:'1.2-2' }} €</strong></p>
              </div>
            </div>
          </ng-container>

        </mat-card-content>
      </mat-card>

    </form>
  </div>

  <div class="ef-loading" *ngIf="isLoading">
    <app-loading-state [message]="uid ? (isBail ? 'Cargando fianza…' : 'Cargando anticipo…') : 'Preparando formulario…'"></app-loading-state>
  </div>

</div>
